<div class="font-family-din flex text-3xl select-none">
  <span class="border-surface-300 ease-out-back inline-block bg-white py-4 transition-all" [class]="tw()">
    {{ content() }}
  </span>
</div>
